<div class="d-flex gap-3">
  <div class="flex-fill d-flex flex-column gap-2">
    <div class="container-box shadow-none">
      <div class="p-3 d-flex align-items-center gap-3">
        <img src="/assets/images/channel-wizards/hvmi/tokeet-hvmi.webp" alt="" height="45" />
        <div>
          <h6 class="mb-0" i18n>HVMI</h6>
          <div class="text-sm" i18n>
            Connect multiple HVMI accounts and sync bookings, prices, guest messages, and more instantly.
          </div>
        </div>
      </div>
      <div class="border-top p-3">
        <div class="alert alert-secondary-danger">
          <i class="cs-icon cs-icon-pray alert-icon" style="font-size: 45px"></i>
          <div class="alert-content">
            <div class="text-semi-bold" i18n>Thank you for your interest</div>
            <ng-container i18n
              >in listing your properties with Marriott's Homes & Villas (HVMI) channel. Marriott accepts a limited
              number of property managers. While AdvanceCM can assist with your application, the final decision is up to
              Marriott.</ng-container
            >
          </div>
        </div>
        <div class="text-semi-bold" i18n>Already Signed Up to Homes & Villas by Marriott?</div>
        <p i18n>
          If you signed up but did not receive an HMC ID, contact your account manager at Homes & Villas by Marriott to
          get it.
        </p>

        <div class="text-semi-bold" i18n>Not Yet Signed Up?</div>
        <p i18n>Fill out Marriott's interest form. Once you receive your HMC ID, come back here.</p>
        <div i18n class="text-semi-bold">Signed Up via a Channel Manager?</div>
        <p i18n>
          This direct integration requires a new HMC ID. Please contact Homes & Villas by Marriott Bonvoy to obtain it.
        </p>
        <div class="alert alert-secondary-warning2 align-items-start">
          <i class="cs-icon cs-icon-alert-triangle2 alert-icon"></i>
          <div class="alert-content">
            <div class="text-semi-bold" i18n>Important Notes</div>
            <ul class="pl-3">
              <li i18n>
                After enabling the AdvanceCM rentals you wish to link and selecting the option to initiate connection,
                you will receive a confirmation email.
              </li>
              <li i18n>Check your email for this confirmation and follow the next steps outlined in the guide.</li>
              <li i18n>An HVMI onboarding team member will contact you to finalize the connections.</li>
            </ul>
          </div>
        </div>

        <form [formGroup]="form" [formEditablePermission]="form" class="step_1_form">
          <div formArrayName="hmcIds" *ngFor="let item of hmcIds.controls; let i = index">
            <div [formGroupName]="i" class="d-flex gap-3">
              <mat-form-field2 class="">
                <mat-label>
                  <ng-container i18n>HMC ID</ng-container>&nbsp;
                  <i
                    matTooltip="HMC ID will be generated by HVMI Supply Onboarding team and shared with connectivity partner as new HMCs are onboarded to push the inventory into HVMI platform"
                    matTooltipPosition="above"
                    i18n-matTooltip
                    class="fal fa-question-circle"
                  ></i>
                </mat-label>
                <input type="text" formControlName="hmcId" matInput disabled />
                <mat-error *ngIf="item['controls'].hmcId.touched && item.hasError('required', ['required'])">
                  <ng-container i18n>HMC ID is required</ng-container>
                </mat-error>
                <mat-error *ngIf="item['controls'].hmcId.touched && item.hasError('required', ['minlength'])">
                  <ng-container i18n>HMC ID must be at least 2 characters long</ng-container>
                </mat-error>
                <mat-error *ngIf="item['controls'].hmcId.touched && item.hasError('required', ['maxlength'])">
                  <ng-container i18n>HMC ID must be at most 30 characters long</ng-container>
                </mat-error>
              </mat-form-field2>
              <button
                (click)="onDisconnect(i)"
                class="btn btn-secondary-danger align-input-row-end"
                type="button"
                [disabled]="1 | isReadonlyRole"
              >
                <span class="cs-icon cs-icon-unlink"></span>
                <ng-container i18n>Disconnect</ng-container>
              </button>
            </div>
          </div>
        </form>

        <form [formGroup]="newForm" [formEditablePermission]="form" class="step_1_form">
          <div class="d-flex gap-3">
            <mat-form-field2 class="">
              <mat-label>
                <ng-container i18n>HMC ID</ng-container>&nbsp;
                <i
                  matTooltip="HMC ID will be generated by HVMI Supply Onboarding team and shared with connectivity partner as new HMCs are onboarded to push the inventory into HVMI platform"
                  matTooltipPosition="above"
                  i18n-matTooltip
                  class="fal fa-question-circle"
                ></i>
              </mat-label>
              <input type="text" formControlName="hmcId" matInput required />
              <mat-error *ngIf="newForm.get('hmcId').touched && newForm.get('hmcId').hasError('required')">
                <ng-container i18n>HMC ID is required</ng-container>
              </mat-error>
              <mat-error *ngIf="newForm.get('hmcId').touched && newForm.get('hmcId').hasError('pattern')">
                <ng-container i18n>HMC ID must be a number</ng-container>
              </mat-error>
              <mat-error *ngIf="newForm.get('hmcId').touched && newForm.get('hmcId').hasError('minlength')">
                <ng-container i18n>HMC ID must be at least 2 characters long</ng-container>
              </mat-error>
              <mat-error *ngIf="newForm.get('hmcId').touched && newForm.get('hmcId').hasError('maxlength')">
                <ng-container i18n>HMC ID must be at most 30 characters long</ng-container>
              </mat-error>
            </mat-form-field2>

            <button
              (click)="onSave(newForm)"
              class="btn btn-secondary-info align-input-row-end"
              type="button"
              [disabled]="(1 | isReadonlyRole) || isConnecting"
            >
              <i class="cs-icon cs-icon-link" *ngIf="!isConnecting"></i>
              <i class="far fa-spin fa-spinner" *ngIf="isConnecting"></i>
              <ng-container i18n>Connect</ng-container>
            </button>
          </div>
        </form>

        <div class="d-flex align-items-center justify-content-end gap-3 border-top p-3">
          <button class="btn btn-secondary-info" (click)="next.emit()" [disabled]="!canMoveToRentalsStep()">
            <ng-container i18n>Continue</ng-container>
            <i class="cs-icon cs-icon-arrow-right-long text-xs"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="channel-wizard-right-wrapper rounded px-4">
    <img src="/assets/images/channel-wizards/hvmi/step1.webp" alt="" class="w-100" />
  </div>
</div>
